<div class="{{localService.selectedLanguageCode}}"
  *ngIf="localService.languageContent && localService.languageContent.paging">
  <div *ngIf="paging">
    <div class="row" *ngIf="paging.totalCount == 0">
      <div class="col-12" style="text-align:center;">
        <div style="margin-top:10%;">
          {{localService.languageContent.paging.no_records}}
        </div>
      </div>
    </div>
    <div class="banner more_options footer" *ngIf="isShowMoreOptions" style="max-width: 500px;right: 0px;"
      [ngStyle]="{'bottom':onGetPagingHeight(-35)}">
      <button class="button_icon button_icon_color" style="top: 5px;"
        (click)="onMoreOptionsClicked(1)">file_download</button>
      <button class="button_icon button_icon_color" style="top: 5px;"
        (click)="onMoreOptionsClicked(2)">bar_chart</button>
      <label class="exclude_on_document_click" *ngIf="!localService.isHideDummy"
        style="margin-left:30px;font-weight:normal;">
        <input type="checkbox" class="exclude_on_document_click" [checked]="isAutoRefreshEnabled"
          (change)="onToggleCheckbox(1)">
        <span class="exclude_on_document_click">&nbsp;{{localService.languageContent.paging.auto_refresh}}&nbsp;</span>
        <input autocomplete="off" class="number en exclude_on_document_click" type="text"
          (keypress)="localService.isNumberOnly($event)" min="5" max="60" style="width:50px;" placeholder="30"
          [(ngModel)]="autoRefreshSeconds" (focus)="onAutoRefrehFocus()" />
        <span class="exclude_on_document_click">&nbsp;{{localService.languageContent.paging.in_secs}}</span>
      </label>
    </div>
    <div class="banner date_range footer" *ngIf="isShowDateRange" [ngStyle]="{'bottom':onGetPagingHeight(-35)}">
      <app-date-picker [isTop]="true" [selectedDate]="paging.dateFromS" (selectedDateChange)="paging.dateFromS = $event"
        (isOpenChange)="localService.onOpenUi(1)"></app-date-picker>
      <span style="float: left;">&nbsp;-&nbsp;&nbsp;</span>
      <app-date-picker [isTop]="true" [selectedDate]="paging.dateToS" (selectedDateChange)="paging.dateToS = $event"
        (isOpenChange)="localService.onOpenUi(1)"></app-date-picker>
    </div>
    <div class="footer freeze_height" *ngIf="!IsSimple" style="min-width: 300px;max-width: calc(100% - 50px);">
      <div style="float: left;">
        <button class="button_icon button_icon_color more_options_icon" style="float: left;top: 5px;"
          [ngStyle]="{'color': isAutoRefreshEnabled ? 'red' : '#008CBA'}" *ngIf="isEnableShowMoreOptions"
          (click)="onShowHideOption($event,1)">more_horiz</button>
        <button class="button_icon button_icon_color" *ngIf="IsShowDateRange" (click)="onShowHideOption($event,2)"
          style="float: left;top: 5px;">date_range</button>
        <button class="button_icon button_icon_color" *ngIf="isShowPrinter" (click)="onPrint()"
          style="float: left;top: 5px;">print</button>
        <app-paging-search-filter *ngIf="isShowSearchFilter" [isShowFilterOption]="isShowFilterOption"
          style="float: left;" [paging]="paging" (onSearchKeyEntered)="onPagingRefresh(0)"
          [isTriggerOnOptionSelect]="isTriggerOnOptionSelect"
          (onCountryChanged)="onCountryUpdated($event)"></app-paging-search-filter>
        <div *ngIf="isShowNavigation" style="float: left;display: inline-flex;">
          <button class="button_icon button_icon_color" style="top:5px;" [disabled]="paging.currentPage <= 1"
            (click)="onPagingRefresh(1)">navigate_before</button>
          <input autocomplete="off" type="number" class="number"
            (keypress)="localService.isNumberOnly($event,numericConfig)"
            [disabled]="paging.currentPage == 1 && paging.totalPage == 1" min="1" max="{{paging.totalPage}}"
            [ngClass]="paging.currentPage != null ? 'en' : ''" [(ngModel)]="paging.currentPage"
            style="max-width: 50px;text-align: right;" title="{{localService.languageContent.paging.page}}"
            placeholder="{{localService.languageContent.paging.page}}" (keydown.enter)="onPagingRefresh(3)"
            (focusout)="onPagingRefresh(3,false)" />
          <span class="en">&nbsp;/&nbsp;{{paging.totalPage}}&nbsp;</span>
          <button class="button_icon button_icon_color " style="top:5px;"
            [disabled]="paging.currentPage == paging.totalPage" (click)="onPagingRefresh(2)">navigate_next</button>
        </div>
      </div>
      <div *ngIf="isShowNavigation" style="float: left;">
        <input autocomplete="off" type="number" class="number"
          (keypress)="localService.isNumberOnly($event,numericConfigDefault)" min="1" max="1000"
          [ngClass]="paging.dataPerPage != null ? 'en' : ''" [(ngModel)]="paging.dataPerPage"
          style="max-width: 50px; text-align: right;" title="{{localService.languageContent.paging.row_count_in_page}}"
          placeholder="{{localService.languageContent.paging.row_count_in_page}}" (keydown.enter)="onPagingRefresh(5)"
          (focusout)="onPagingRefresh(5,false)" />
      </div>
      <div style="float: left;top: 5px;position: relative;">
        <div style="font-weight:bold;float: left;max-width: 50px;overflow: hidden;margin-left: 15px;">
          {{localService.languageContent.paging.total_count}}</div>
        <span class="en">&nbsp;:&nbsp;{{paging.totalCount}}</span>
      </div>
      <div class="icon_action_header">
        <button class="button_icon button_icon_color " style="top:-5px;"
          [ngStyle]="{transform : paging.isReverseOrder ? 'rotate(180deg)' : 'rotate(0deg)'}"
          (click)="onPagingRefresh(4)"
          title="{{paging.isReverseOrder ? localService.languageContent.paging.show_asc : localService.languageContent.paging.show_desc}}">sort</button>
        <button class="button_icon button_icon_color " style="top:-5px;"
          [ngClass]="isUpdateDuringLanguageChange ? 'on_language_changed' : ''" (click)="onPagingRefresh(0)"
          title="{{localService.languageContent.common.reset}}"
          (click)="onPagingRefresh(0)">replay_circle_filled</button>
      </div>
    </div>
    <div *ngIf="IsShowSingleCalenderClicked" class="banner" style="position: absolute;bottom: 70px;right: 20px;">
      <app-date-picker [isTop]="true" [selectedDate]="paging.dateFromS"
        (selectedDateChange)="paging.dateFromS = $event;onSelect();"></app-date-picker>
      <app-date-picker [isTop]="true" [selectedDate]="paging.dateToS"
        (selectedDateChange)="paging.dateToS = $event;onSelect();"></app-date-picker>
    </div>
    <div *ngIf="IsSimple" class="footer freeze_height">
      <div style="float:left;width: fit-content;">
        <app-date-picker [isTop]="true" *ngIf="IsShowSingleCalender" [selectedDate]="paging.dateFromS"
          (selectedDateChange)="paging.dateFromS = $event;onSelect();"></app-date-picker>
        <button *ngIf="IsShowSimpleCalenderRange" class="button_icon button_icon_color" style="top:3px"
          (click)="IsShowSingleCalenderClicked = !IsShowSingleCalenderClicked" type="button">calendar_month</button>
        <span *ngIf="IsShowSimpleCalenderRange" class="en"
          style="top: -3px;position: relative;">({{paging.totalCount}})&nbsp;</span>
        <app-paging-search-filter *ngIf="IsSimpleSearchBarReq" [isShowShoppingCart]="isShowShoppingCart"
          [countToShow]="countToShow" [isShowFilterOption]="isShowFilterOption" [paging]="paging"
          [width]="'calc(100% - 70px)'" (onSearchKeyEntered)="onPagingRefresh(0)" [isShowSearchButton]="true"
          [isTriggerOnOptionSelect]="isTriggerOnOptionSelect" (onShoppingClicked)="onAction(1)"
          (onCountryChanged)="onCountryUpdated($event)"></app-paging-search-filter>
      </div>
      <div style="float:right;top: 5px;position: relative;">
        <span *ngIf="IsShowTotalCount" class="en"
          style="float: left;top: -3px;position: relative;">({{paging.totalCount}})&nbsp;</span>
        <button class="button_icon button_icon_color " [disabled]="paging.currentPage == 1"
          (click)="onPagingRefresh(1)">arrow_circle_left</button>
        <button class="button_icon button_icon_color " [disabled]="paging.currentPage == paging.totalPage"
          (click)="onPagingRefresh(2)">arrow_circle_right</button>
        <button class="button_icon button_icon_color "
          [ngClass]="isUpdateDuringLanguageChange ? 'on_language_changed' : ''" (click)="onPagingRefresh(0)"
          title="{{localService.languageContent.common.reset}}">replay_circle_filled</button>
        <button class="button_icon button_icon_color " *ngIf="isShowMoreOptions"
          (click)="isShowSummary=!isShowSummary">more</button>
      </div>
    </div>
  </div>
  <div class="banner footer_summary" *ngIf="isShowSummary && paging">
    <div>
      <app-label [Text]="localService.languageContent.paging.page" [IsColonRequired]="true"></app-label>
      <span class="en" *ngIf="paging.totalCount == 0">0&nbsp;/&nbsp;0&nbsp;</span>
      <span class="en"
        *ngIf="paging.totalCount > 0">{{paging.currentPage}}&nbsp;/&nbsp;{{paging.totalPage}}&nbsp;</span>
    </div>
    <div>
      <app-label [Text]="localService.languageContent.paging.row_count_in_page" [IsColonRequired]="true"></app-label>
      <span class="en">&nbsp;{{paging.dataPerPage}}</span>
    </div>
    <div>
      <app-label [Text]="localService.languageContent.paging.total_count" [IsColonRequired]="true"></app-label>
      <span class="en">&nbsp;{{paging.totalCount}}</span>
    </div>
  </div>
</div>